import * as React from 'react'
import styles from './EmbedError.module.scss'
import { ReactComponent as ErrorIcon16 } from './icons/error16.svg'
import { ReactComponent as ErrorIcon36 } from './icons/error36.svg'
import { Button } from 'components/Button'
import cx from 'classnames'
import { useQuery } from 'react-query'
import { AnchorOrDiv } from './common'
import { useModals } from 'almanac-ui/Modal'
import { IntegrationsModal } from 'components/IntegrationsModal/IntegrationsModal'

export type EmbedErrorProps = {
  refetch: ReturnType<typeof useQuery>['refetch']
  mode: 'frame' | 'card' | 'inline'
  link: string
  preview?: true
}

export const EmbedError: React.FC<React.PropsWithChildren<EmbedErrorProps>> = (props) => {
  const { mode, link, refetch, preview } = props
  const { openModal } = useModals()

  switch (mode) {
    case 'frame':
      return (
        <div className={cx(styles.error, styles.frame)}>
          <ErrorIcon36 width={36} height={36} className={styles.icon} />
          <div className={styles.errorMsg}>There is an issue with this embed.</div>
          <a href={link} rel="noopener noreferrer" target="_blank">
            {link}
          </a>

          <div className={styles.buttons}>
            <Button className={styles.refreshBtn} variant="secondary" onPress={() => refetch()}>
              Refresh
            </Button>
            {!preview && (
              <Button variant="tertiary" className={styles.settings} onPress={() => openModal(IntegrationsModal, {})}>
                Open Integration Settings
              </Button>
            )}
          </div>
        </div>
      )
    case 'card':
      return (
        <div className={cx(styles.error, styles.card)}>
          <ErrorIcon36 width={36} height={36} className={styles.icon} />
          <div className={styles.errorMsg}>There is an issue with this embed.</div>
          <AnchorOrDiv className={styles.link} link={preview ? undefined : link}>
            {link}
          </AnchorOrDiv>
          {!preview && (
            <Button variant="tertiary" className={styles.settings} onPress={() => openModal(IntegrationsModal, {})}>
              Open Integration Settings
            </Button>
          )}
          <Button className={styles.refreshBtn} variant="secondary" onPress={() => refetch()}>
            Refresh
          </Button>
        </div>
      )
    case 'inline':
      return (
        <div className={cx(styles.error, styles.inline)}>
          <ErrorIcon16 width={16} height={16} />
          <a href={link} rel="noopener noreferrer" target="_blank">
            {link}
          </a>
          <Button variant="tertiary" onPress={() => openModal(IntegrationsModal, {})}>
            Settings
          </Button>
          <Button className={styles.refreshBtn} variant="tertiary" onPress={() => refetch()}>
            Refresh
          </Button>
        </div>
      )
  }
}
